import { Directive, forwardRef } from '@angular/core';
import { FormControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { formatCnpj, validCnpj } from '../../utils';

const CNPJ_LENGTH: number = 18;

@Directive({
  selector: '[appCnpj]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CnpjDirective),
      multi: true,
    },
  ],
  standalone: false,
})
export class CnpjDirective implements Validator {
  validate(control: FormControl): ValidationErrors | null {
    return CnpjDirective.isValid(control.value);
  }

  static isValid = (value: string): ValidationErrors | null => {
    const sanitize: string = formatCnpj(value);
    if (sanitize.length !== CNPJ_LENGTH) {
      return { error: true };
    }
    return value && validCnpj(value) ? null : { error: true };
  };
}
